export const trimmingOverwhelm = 4e5;

export const trimWorkerExecutor = (
  event: MessageEvent<{
    data: Uint8ClampedArray;
    width: number;
    height: number;
  }>,
) => {
  const workerData = event.data;

  const { width, height } = workerData;

  const size = width * height;

  let top = -1;
  let bottom = -1;
  let left = -1;
  let right = -1;

  let topIndex = 0;

  let bottomIndex = workerData.data.length - 4;

  let leftIteration = 0;
  const leftStartIndex = (height - 1) * width * 4;
  let leftIndex = leftStartIndex;

  let rightIteration = 0;
  const rightStartIndex = (width - 1 + (height - 1) * width) * 4;
  let rightIndex = rightStartIndex;

  const rowSize = width * 4;

  let iterationsAmount = 0;

  do {
    if (top === -1) {
      if (workerData.data[topIndex + 3] !== 0) {
        top = ~~(topIndex / 4 / width);
      } else {
        topIndex += 4;
      }
    }

    if (bottom === -1) {
      if (workerData.data[bottomIndex + 3] !== 0) {
        bottom = ~~(bottomIndex / 4 / width);
      } else {
        bottomIndex -= 4;
      }
    }

    if (left === -1) {
      if (workerData.data[leftIndex + 3] !== 0) {
        left = (leftIndex / 4) % width;
      } else {
        leftIndex = leftIndex - rowSize;
        leftIteration++;

        if (!(leftIteration % height)) {
          leftIndex = leftStartIndex + 4 * (leftIteration / height);
        }
      }
    }

    if (right === -1) {
      if (workerData.data[rightIndex + 3] !== 0) {
        right = (rightIndex / 4) % width;
      } else {
        rightIndex = rightIndex - rowSize;
        rightIteration++;

        if (!(rightIteration % height)) {
          rightIndex = rightStartIndex - 4 * (rightIteration / height);
        }
      }
    }

    iterationsAmount++;
  } while (iterationsAmount < size && (top === -1 || bottom === -1 || left === -1 || right === -1));

  right = right - left + 1;
  bottom = bottom - top + 1;

  return { x: left, y: top, width: right, height: bottom };
};
